// extracted by mini-css-extract-plugin
export default {"container":"_J-z","topReviewHeading":"aK-z","criticalReview":"bK-z","favorableReview":"cK-z","vsSeparator":"dK-z"};